import { useEffect } from "react";
import { ArrowLeft } from "lucide-react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { pageTitle } from "@/lib/app";

/**
 * Seitenkopf: optionaler Zurück-Button, Titel, Badges direkt daneben,
 * rechts die Aktionen (sekundäre zuerst, Primär-Button zuletzt).
 */
export function PageHeader({
  title,
  backTo,
  backLabel = "Zurück",
  badges,
  meta,
  actions,
}: {
  title: React.ReactNode;
  backTo?: string;
  backLabel?: string;
  badges?: React.ReactNode;
  /** Kleine Zeile unter dem Titel (z. B. Datum, Kanal). */
  meta?: React.ReactNode;
  actions?: React.ReactNode;
}) {
  // Tab-Titel folgt dem Seitentitel, sofern der ein reiner Text ist.
  const tabTitle = typeof title === "string" ? title : undefined;
  useEffect(() => {
    document.title = pageTitle(tabTitle);
  }, [tabTitle]);

  return (
    <header className="mb-4 flex flex-wrap items-start gap-x-3 gap-y-2">
      {backTo && (
        <Button variant="ghost" size="icon-sm" asChild className="mt-0.5">
          <Link to={backTo} aria-label={backLabel}>
            <ArrowLeft />
          </Link>
        </Button>
      )}
      <div className="min-w-0 flex-1">
        <div className="flex flex-wrap items-center gap-2">
          <h1 className="text-xl font-semibold tracking-tight break-all sm:break-normal">
            {title}
          </h1>
          {badges}
        </div>
        {meta && (
          <div className="mt-0.5 text-sm text-muted-foreground">{meta}</div>
        )}
      </div>
      {actions && (
        // Auf schmalen Bildschirmen eigene Zeile, damit lange Titel nicht überdeckt werden.
        <div className="flex w-full flex-wrap items-center gap-2 sm:w-auto">
          {actions}
        </div>
      )}
    </header>
  );
}
